import { useEffect, useState } from 'react';
import axios from 'axios';
import { apiUrl } from '../config/api';

// Whether a new loan can be applied for, as the API decides it: a client asks
// GET /api/loans/my-summary (can_apply, apply_blocked_message); staff pass the
// client's id and ask GET /api/clients/:id/can-add-loan. `message` is the
// API's own explanation, shown as it is.
export default function useClientHasActiveLoan(user, refreshKey = 0, clientId = null) {
  const [hasActiveLoan, setHasActiveLoan] = useState(false);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    setError(null);
    const fetchStatus = async () => {
      try {
        const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
        if (clientId) {
          const res = await axios.get(apiUrl(`/api/clients/${clientId}/can-add-loan`), { headers });
          setHasActiveLoan(res.data?.canAdd === false);
          setMessage(res.data?.message || null);
        } else {
          const res = await axios.get(apiUrl('/api/loans/my-summary'), { headers });
          setHasActiveLoan(res.data?.can_apply === false);
          setMessage(res.data?.apply_blocked_message || null);
        }
      } catch (err) {
        setError(err.response?.data?.error || 'Error checking active loans');
        setHasActiveLoan(false);
        setMessage(null);
      } finally {
        setLoading(false);
      }
    };
    fetchStatus();
  }, [user, refreshKey, clientId]);

  return { hasActiveLoan, message, loading, error };
}
